import { useColors } from '../hooks/useColors';

const PageLoader = ({ message = 'Loading...', inline = false }) => {
  const C = useColors();

  const spinner = (
    <div className="flex flex-col items-center gap-5" data-testid="page-loader">
      <div className="relative w-14 h-14">
        <div
          className="absolute inset-0 spinner-outer"
          style={{
            borderRadius: '9999px',
            border: '2px solid rgba(255,255,255,0.06)',
            borderTopColor: C.purple,
            borderRightColor: C.cyan,
          }}
        />
        <div
          className="absolute inset-2 spinner-inner"
          style={{
            borderRadius: '9999px',
            border: '2px solid rgba(255,255,255,0.04)',
            borderBottomColor: C.purple,
            borderLeftColor: C.cyan,
          }}
        />
      </div>
      <p className="text-xs font-medium tracking-widest uppercase" style={{ color: C.text2 }}>
        {message}
      </p>
    </div>
  );

  if (inline) {
    return <div className="flex items-center justify-center py-16">{spinner}</div>;
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "transparent" }}>
      {spinner}
    </div>
  );
};

export default PageLoader;
